<template>
    <div class="container-fluid" style="height:100%">
        <Loader />
        <b-row v-if="!pageloading" class="animated fadeIn backgroundGradient" style="height:100%"> 

            <b-col v-if="userSuspended == true" xl="5" lg="7" md="12" class="col d-flex align-items-center justify-content-center loginPanel">
              <div class="ml-4 mt-5 mb-5 mr-4">
                <div  class="h-100 mt-5 mb-5">
                    <h1 class="typo-display">{{$t('home.suspended_title',{name: $store.getters.userName})}}</h1>
                    <h2 class="typo-display2">{{$t('home.suspended_message')}}</h2>               
                    
                </div>
                
              </div>
            </b-col>
            
            <b-col v-else-if="$store.state.userLastPlants.length == 0" xl="5" lg="7" md="12" class="col d-flex align-items-center justify-content-center loginPanel">
              <div class="ml-4 mt-5 mb-5 mr-4">
               
                <!-- Utente basic? -->
                <div v-if="$store.getters.isBasic">
                  <h1 class="typo-display">{{$t('welcome',{name: $store.getters.userName})}}</h1>
                  <h2 class="typo-display2">{{$t('home.lead')}}</h2>
                    <!-- <div class="embed-responsive embed-responsive-16by9 mt-5 mb-5">
                      <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/eaEE2uXBMg4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> -->
                    <h2 class="typo-display2 mt-5">{{$t('home.user_installer_title')}}</h2>
                    <label class="mt-2 typo-subtit">{{$t('home.user_register_as_installer_intro')}}</label>
                    <p class="lead mt-3">
                      <b-button @click="mostraPaginaUserProfile" class="bg-primary noborder btn-pill p-2"><span class="px-5 text-pill">{{$t('home.register_as_installer')}}</span></b-button>
                    </p>
                    <h2 class="typo-display2 mt-2">{{$t('home.oppure')}}</h2>
                    <p v-if="invitoPendente != null" class="mt-4 typo-submit" style="margin-bottom:50px;">
                      <span v-html="$t('home.accetta_invito_pendente_message',{dataInvito: moment(invitoPendente.dateRequest,).format('DD/MM/YYYY'), impianto: invitoPendente.plantName })" ></span><br/><br/>
                      {{$t('home.accetta_invito_ora')}}<br/><br/>
                      <b-button @click="accettaInvitoPendente" class="bg-primary noborder btn-pill p-2"><span class="px-5 text-pill">{{$t('home.accetta_invito')}}</span></b-button>
                    </p>
                    <label v-else class="mt-2 typo-subtit" style="margin-bottom:50px">{{$t('home.user_register_as_client_intro')}}</label>
                </div>

                <div v-else-if="$store.getters.userType == 'client'">
                  <h1 class="typo-display">{{$t('welcome',{name: $store.getters.userName})}}</h1>
                  <p v-if="invitoPendente != null" class="mt-4 typo-submit" style="margin-bottom:50px;">
                      <span v-html="$t('home.accetta_invito_pendente_message',{dataInvito: moment(invitoPendente.dateRequest,).format('DD/MM/YYYY'), impianto: invitoPendente.plantName })" ></span><br/><br/>
                      {{$t('home.accetta_invito_ora')}}<br/><br/>
                      <b-button @click="accettaInvitoPendente" class="bg-primary noborder btn-pill p-2"><span class="px-5 text-pill">{{$t('home.accetta_invito')}}</span></b-button>
                    </p>    
                </div>

                <!-- Nessun impianto? -->
                <div v-else class="h-100 mt-5 mb-5">
                
                    <h1 class="typo-display">{{$t('compliment',{name: $store.getters.userName})}}</h1>
                    <h2 class="typo-display2">{{$t('home.no_plants_intro')}}</h2>
                    <add-plant class="mt-5"/>
                    <p v-if="invitoPendente != null" class="mt-4 typo-submit" style="margin-bottom:50px;">
                      <span v-html="$t('home.accetta_invito_pendente_message',{dataInvito: moment(invitoPendente.dateRequest,).format('DD/MM/YYYY'), impianto: invitoPendente.plantName })" ></span><br/><br/>
                      {{$t('home.accetta_invito_ora')}}<br/><br/>
                      <b-button @click="accettaInvitoPendente" class="bg-primary noborder btn-pill p-2"><span class="px-5 text-pill">{{$t('home.accetta_invito')}}</span></b-button>
                    </p>               
                </div>
                
              </div>
            </b-col>      
        </b-row>

  <!-- Crea nuovo installatore Modal -->
  <b-modal 
    ref="modal" 
    size="lg" 
    id="modal-installer"  
    :title="$t('user_modal.installer_title')" 
    :ok-title="$t('user_modal.button_save')" 
    :cancel-title="$t('user_modal.button_cancel')" 
    @ok="handleOk($event)"
    @show="chargeCurrentUserSettingsInstaller">
    
      <b-form-group>
          <b-row>
            <b-col sm="6">
                <b-form-group>
                    <label for="label-installer-name" class="ml-2">{{$t("user_modal.label_name")}}</label>
                    <b-form-input v-model="userName" type="text" :state="validation_userName" id="placeholder-installer-name" :placeholder="$t('user_modal.placeholder_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>        
            <b-col sm="6">
                <b-form-group>
                    <label for="label-installer-surname" class="ml-2">{{$t("user_modal.label_surname")}}</label>
                    <b-form-input v-model="userSurname" type="text" :state="validation_userSurname" id="placeholder-installer-surname" :placeholder="$t('user_modal.placeholder_surname')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userSurname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>          
      </b-form-group>
      <b-form-group>
          <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label for="label-installer-business-name" class="ml-2">{{$t("user_modal.label_business_name")}}</label>
                    <b-form-input v-model="userbusinessName" type="text" :state="validation_userbusinessName" id="placeholder-installer-business-name" :placeholder="$t('user_modal.placeholder_business_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>    
          </b-row>
          <b-row>      
            <b-col sm="6">
                <b-form-group>
                    <label for="label-installer-piva" class="ml-2">{{$t("user_modal.label_piva")}}</label>
                    <b-form-input v-model="userPiva" type="text" :state="validation_userPiva" id="placeholder-installer-piva" :placeholder="$t('user_modal.placeholder_piva')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label for="label-installer-phone" class="ml-2">{{$t("user_modal.label_phone")}}</label>
                    <b-form-input v-model="userPhone" type="text" :state="validation_userPhone" id="placeholder-installer-phone" :placeholder="$t('user_modal.placeholder_phone')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPhone">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>          
      </b-form-group>
      <b-form-group>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-installer-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                <b-form-input v-model="userStreet" type="text" :state="validation_userStreet" id="placeholder-installer-street" :placeholder="$t('user_modal.placeholder_street')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-installer-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                <b-form-input v-model="userNumber" type="text" :state="validation_userNumber" id="placeholder-installer-number" :placeholder="$t('user_modal.placeholder_number')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
      </b-form-group>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-installer-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                <b-form-input v-model="userCity" type="text" :state="validation_userCity" id="placeholder-installer-city" :placeholder="$t('user_modal.placeholder_city')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-installer-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                <b-form-input v-model="userCap" type="text" :state="validation_userCap" id="placeholder-installer-cap" :placeholder="$t('user_modal.placeholder_cap')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group>
            <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-installer-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                <b-form-input v-model="userProv" type="text" :state="validation_userProv" id="placeholder-installer-prov" :placeholder="$t('user_modal.placeholder_prov')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-installer-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                <b-form-select v-model="userCountry" :country="country">
                    <option :value="null">{{$t("user_modal.placeholder_country")}}</option>        
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Åland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia, Plurinational State of</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">Congo, the Democratic Republic of the</option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curaçao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">Heard Island and McDonald Islands</option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, Democratic People's Republic of</option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Réunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthélemy</option>
                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (French part)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Dutch part)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">United States Minor Outlying Islands</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                </b-form-select> 
              </b-form-group>
            </b-col>
            </b-row>   
          </b-form-group>


  </b-modal>

 <!-- Crea nuovo cliente Modal -->
  <b-modal 
    ref="modal" 
    size="lg" 
    id="modal-client"  
    :title="$t('user_modal.client_title')" 
    :ok-title="$t('user_modal.button_save')" 
    :cancel-title="$t('user_modal.button_cancel')" 
    @ok="handleOk($event)"
    @show="chargeCurrentUserSettingsClient">

      <b-form-group>
          <b-row>
            <b-col sm="6">
                <b-form-group>
                    <label for="label-name" class="ml-2">{{$t("user_modal.label_name")}}</label>
                    <b-form-input v-model="userName" type="text" :state="validation_userName" id="placeholder-installer-name" :placeholder="$t('user_modal.placeholder_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>        
            <b-col sm="6">
                <b-form-group>
                    <label for="label-surname" class="ml-2">{{$t("user_modal.label_surname")}}</label>
                    <b-form-input v-model="userSurname" type="text" :state="validation_userSurname" id="placeholder-installer-surname" :placeholder="$t('user_modal.placeholder_surname')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userSurname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>          
      </b-form-group>
      <b-form-group>
          <b-row>
           <b-col sm="12">
               <b-form-group :label='$t("user_modal.label_people_or_company")' class="ml-2">
                    <b-form-radio class="ml-4 mb-2" v-model="picked" name="PersonComp" value="person">{{$t("user_modal.label_people")}}</b-form-radio>
                    <b-form-radio class="ml-4 mb-2" v-model="picked" name="PersonComp" value="company">{{$t("user_modal.label_company")}}</b-form-radio>
                </b-form-group>
            </b-col>    
            <b-col sm="12">
                <b-form-group v-if="picked=='company'">
                    <label for="label-business-name" class="ml-2">{{$t("user_modal.label_business_name")}}</label>
                    <b-form-input v-model="userbusinessName" type="text" :state="validation_userbusinessName" id="placeholder-installer-business-name" :placeholder="$t('user_modal.placeholder_business_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>    
          </b-row>
          <b-row>      
            <b-col sm="12">
                <b-form-group v-if="picked=='company'">
                    <label for="label-piva" class="ml-2">{{$t("user_modal.label_piva")}}</label>
                    <b-form-input v-model="userPiva" type="text" :state="validation_userPiva" id="placeholder-installer-piva" :placeholder="$t('user_modal.placeholder_piva')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <b-form-group>
                    <label for="label-phone" class="ml-2">{{$t("user_modal.label_phone")}}</label>
                    <b-form-input v-model="userPhone" type="text" :state="validation_userPhone" id="placeholder-installer-phone" :placeholder="$t('user_modal.placeholder_phone')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPhone">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>          
      </b-form-group>
      <b-form-group>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-installer-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                <b-form-input v-model="userStreet" type="text" :state="validation_userStreet" id="placeholder-installer-street" :placeholder="$t('user_modal.placeholder_street')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-installer-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                <b-form-input v-model="userNumber" type="text" :state="validation_userNumber" id="placeholder-installer-number" :placeholder="$t('user_modal.placeholder_number')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
      </b-form-group>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-installer-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                <b-form-input v-model="userCity" type="text" :state="validation_userCity" id="placeholder-installer-city" :placeholder="$t('user_modal.placeholder_city')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-installer-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                <b-form-input v-model="userCap" type="text" :state="validation_userCap" id="placeholder-installer-cap" :placeholder="$t('user_modal.placeholder_cap')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group>
            <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-installer-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                <b-form-input v-model="userProv" type="text" :state="validation_userProv" id="placeholder-installer-prov" :placeholder="$t('user_modal.placeholder_prov')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-installer-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                <b-form-select v-model="userCountry" :country="country" >
                    <option :value="null">{{$t("user_modal.placeholder_country")}}</option>        
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Åland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia, Plurinational State of</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">Congo, the Democratic Republic of the</option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curaçao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">Heard Island and McDonald Islands</option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, Democratic People's Republic of</option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Réunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthélemy</option>
                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (French part)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Dutch part)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">United States Minor Outlying Islands</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                </b-form-select> 
              </b-form-group>
            </b-col>
            </b-row>   
            <b-row>
               <b-col cols="12">
                  <label>{{$t("user_modal.fields")}}</label> 
               </b-col>    
            </b-row>    
          </b-form-group>

  </b-modal>

    </div>
</template>

<script>

import Vue from "vue";
import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'
import {showAt, hideAt} from 'vue-breakpoints'

import AddPlant from '@/components/AddPlant'
import { mapState, install } from 'vuex';


export default {
    name: 'Home',
    components: {
        AddPlant,
        showAt,
        hideAt
    },    
    props: [],
    data() {
        return {
            pageloading: true,
            userName: '',
            userSurname:'',
            userbusinessName:'',
            userPiva:'',
            userPhone:'',
            userStreet:'',
            userNumber:'',
            userCity:'',
            userCap:'',
            userProv:'',
            userCountry:'IT',
            country:null,
            saveSubmit:'false',
            picked:"company",
            userType:"",
            userSuspended: false,
            checkedInvitoPendente: false,
            invitoPendente: null
        }
    },
    mounted(){
        console.log("MOUNTED",this.pageloading);
        if (this.$store.state.loading==false && this.$store.state.user != null && (this.$store.state.user.validation == 'suspended' || this.$store.state.user.validation == 'disabled')) {
          this.userSuspended = true;
          this.pageloading=false;
          return;
        }
        if (this.$store.state.userLastPlants.length <= 0 && this.$store.state.loading==false) {
          this.pageloading=false;
        }
    },
    computed: {
        ...mapState(['loading']),
        nomeUtente() {
            if (this.$store.getters.user == null || this.$store.getters.user.attributes == null) return 'User';
            return this.$store.getters.user.attributes.name;
        },
        validation_userName() {
            if(this.saveSubmit==true) return this.userName.length > 0
        },
        validation_userSurname() {
            if(this.saveSubmit==true) return this.userSurname.length > 0
        },
        validation_userbusinessName() {
            if(this.saveSubmit==true) return this.userbusinessName.length > 0
        },
        validation_userStreet() {
            if(this.saveSubmit==true) return this.userStreet.length > 0
        },
        validation_userPiva() {
            if(this.saveSubmit==true) return this.userPiva.length > 7 && this.userPiva.length < 13
        },
        validation_userPhone() {
            if(this.saveSubmit==true) return this.userPhone.length > 0
        },
        validation_userNumber() {
            if(this.saveSubmit==true) return this.userNumber.length > 0
        },
        validation_userCity() {
            if(this.saveSubmit==true) return this.userCity.length > 0
        },  
        validation_userCap() {
            if(this.saveSubmit==true) return this.userCap.length > 0
        },   
        validation_userProv() {
            if(this.saveSubmit==true) return this.userProv.length > 0
        },    
        validation_userCountry() {
            if(this.saveSubmit==true) return this.userCountry.length > 0
        },
    },
    watch: {
        async loading(val,oldval) {
            if (val == false) {
                console.log("finito loading, user, lastplants, invite:", this.$store.state.user, this.$store.state.userLastPlants.length, this.$store.state.invite)
                console.log("DATA CLIENT REG",this.$store.state.clientRegistrationData);

                if (this.$store.state.user != null && (this.$store.state.user.validation == 'suspended' || this.$store.state.user.validation == 'disabled')) {
                  console.log("Home - Utente sospeso");
                  this.userSuspended = true;
                  this.pageloading = false;
                  return;
                }

                if (this.$store.state.invite != null && this.$store.getters.user != null) {
                    console.log("home, devo gestire invito utente di tipo " + this.$store.state.inviteType+", usertype=" + this.$store.getters.userType);
                    if (this.$store.state.inviteType == 'client') {
                        
                        if(this.$store.getters.userType=='basic' && this.$store.state.clientRegistrationData!=null)
                        {                         
                          console.log("home, è un utente che ha compilato il form di registrazione come cliente",this.$store.state.clientRegistrationData)
                          var clientData=this.$store.state.clientRegistrationData;
                     
                          this.userName=clientData.name;
                          this.userSurname=clientData.surname;
                          this.userPhone=clientData.phone;
                          this.userStreet=clientData.street;
                          this.userNumber=clientData.housenumber;
                          this.userCity=clientData.city;
                          this.userCap=clientData.cap;
                          this.userProv=clientData.prov;
                          this.userCountry=clientData.country;
                          if(clientData.businessName)
                          {
                            this.picked="company";
                            this.userbusinessName=clientData.businessName;
                            this.userPiva=clientData.piva;
                          }
                          else
                          {
                            this.picked="person";
                          }
                          this.userType="client";

                          //this.saveProfile();
                          this.$store.dispatch("dbSaveProfile",{"name":this.userName, "surname":this.userSurname, "businessname":this.userbusinessName, "piva":this.userPiva,"phone":this.userPhone, "street":this.userStreet, "housenumber":this.userNumber,"city":this.userCity,"cap":this.userCap,"prov":this.userProv,"country":this.userCountry,"userType":this.userType});
                          //this.$router.go();
                          return;
                        }

                        if (this.$store.getters.userType == 'basic') {
                            console.log("utente corrente deve fare registrazione a client")
                            let self = this;
                            this.$bvModal.msgBoxOk('Per attivare l\'invito a diventare proprietario dell\'impianto è necessario completare il form di registrazione', {
                                title: 'Attenzione!',
                                okVariant: 'primary',
                                okTitle: "Ok, Procedi",
                                centered: true
                            }).then((value) => {
                                self.$bvModal.show("modal-client");
                            });

                            return;
                        }
                    }
                    console.log("Invia accetta invito");
                    this.$store.dispatch('acceptInvite');
                    return;
                }

                const cmdResp = this.$store.state.commandResponse;
                console.log("cmdResp =",cmdResp);

                if (cmdResp != null && !cmdResp.pending && cmdResp.command == 'saveProfile' && this.$store.state.invite != null) {
                  console.log("Invia accetta invito dopo registrazione form");
                  this.$store.dispatch('acceptInvite');
                  return;
                }


                if (cmdResp != null && !cmdResp.pending && cmdResp.command == 'acceptInvite') {
                    console.log("ricevuta risposta invito -->", cmdResp.response, this.picked);
                    
                    if (cmdResp.response.data.success) {
                        const plantId=cmdResp.response.data.plantId;
                        this.$store.state.commandResponse.command = '';


                        var tipo = this.picked;
                        var daticliente = {}
                        if (tipo == 'company' && (this.userbusinessName == null || this.userbusinessName == "")) {
                          var u = this.$store.state.user;
                          daticliente = {
                            type: 'company',
                            businessname: u.businessname,
                            name: u.name,
                            surname: u.surname,
                            piva: u.piva,
                            phone:  u.phone,
                            email: u.email,
                            address: {
                              "country": u.country,
                              "cap": u.cap,
                              "prov": u.prov,
                              "housenumber": u.housenumber,
                              "city": u.city,
                              "street": u.street
                            }
                          }
                        } else {
                          daticliente = {
                            type: this.picked,
                            businessname: (this.picked == 'company') ? this.userbusinessName : "",
                            name: (tipo == 'company') ? "" : this.userName,
                            surname: (tipo == 'company') ? "" : this.userSurname,
                            piva: (tipo == 'company') ? this.userPiva : "",
                            phone:  this.userPhone || "",
                            email: this.$store.state.user.email || "",
                            address: {
                              "country": this.userCountry,
                              "cap": this.userCap,
                              "prov": this.userProv,
                              "housenumber": this.userNumber,
                              "city": this.userCity,
                              "street": this.userStreet
                            }
                          }
                        }

                           
                          /*console.log("cliente:",daticliente);
                          let self = this;

                          setTimeout(async function() {
                            try {
                              console.log("salvo dati cliente invitato");
                              var risposta = await self.$store.dispatch('aggiornaClienteImpianto', {mode:'form',plantId: plantId, datiCliente: daticliente});
                              console.log("risposta:",risposta);
                            } catch (xx) {
                              console.log("errore impostando cliente impianto",xx)
                            }

                          }, 3000);*/

                          






                        //this.$router.push({name: 'HomeImpianto', params: {pid: cmdResp.response.data.plantId}});
                        this.$store.dispatch("loadUserDetails",this.$store.state.user.username);
                        return;
                    } else {
                        
                        this.$bvModal.msgBoxOk('Si è verificato un errore con l\'accettazione dell\'invito:\n' + cmdResp.response.data.error, {
                                title: 'Attenzione!',
                                okVariant: 'danger',
                                centered: true
                        });
                        this.$store.state.commandResponse.command = '';
                        
                    }
                    
                    
                }
                if (cmdResp != null && !cmdResp.pending && cmdResp.command == 'checkInvitoPendente' && cmdResp.response.data.error!="INVITE_NOT_FOUND" && this.$store.state.userLastPlants.length <=0) {
                    console.log("ricevuta risposta checkInvitoPendente -->", cmdResp.response);
                    this.pageloading = false;
                    this.invitoPendente = cmdResp.response.data.invite;
                    return;
                }

                if (this.$store.getters.userType == 'admin') {
                  this.$router.push({name: 'NTOHome'})
                  return;
                }
                if (this.$store.getters.userType == 'analyst') {
                  this.$router.push({name: 'BAHome'})
                  return;
                }
                if (this.$store.state.userLastPlants.length > 0) {
                    const plantId = this.$store.state.userLastPlants[0].id
                    this.$router.push({name: 'HomeImpianto', params: {pid: plantId}})
                } else {
                    this.pageloading = false
                    if (!this.checkedInvitoPendente) {
                      this.checkedInvitoPendente = true;
                      console.log("utente senza plant, verifico se ha invito pendente");
                      this.$store.dispatch('getInvitoPendente');
                    }
                    
                }
            }
        }
    },
    methods: {
      accettaInvitoPendente() {
        this.$store.state.loading = true;
        this.$store.state.invite = this.invitoPendente.invite_id;
        this.$store.state.inviteType = this.invitoPendente.role;
        let self = this;
        window.setTimeout(function() {self.$store.state.loading = false},2000);
      },
      mostraPaginaUserProfile() {
        console.log("Goto Profilo", this.$store.getters.userId)
        this.$router.push({
          name: "UserProfile",
          params: { userId: this.$store.getters.userId, event: "InstallerRegFirst"}
        });
      },
      chargeCurrentUserSettingsInstaller() {
        this.userName=this.$store.state.user.name;
        this.userSurname=this.$store.state.user.surname;
        this.userType="installer";
        },
      chargeCurrentUserSettingsClient() {
        this.userName=this.$store.state.user.name;
        this.userSurname=this.$store.state.user.surname;
        this.userType="client";
        },
     async cliccato() {
            /*console.log("cliccato!")
            let user = await Auth.currentAuthenticatedUser()
            console.log(user)
            let sess = await Auth.currentSession()
            console.log(sess)
            try {
                let resp = await API.get('testapi1','/impianti',{

                    queryStringParameters: {
                        id: "1",
                        nome: "fabio"
                    }
                })
                console.log(resp)
            } catch (err) {
                console.log("errore")
                console.log(err)
            }*/

            try {
                console.log("cliccato!")
                const jwt = require('jsonwebtoken');
                const jwkToPem = require('jwk-to-pem');
                const axios = require('axios');
                var token = this.$store.getters.user.signInUserSession.idToken.jwtToken;
                console.log(token);
                var decoded = jwt.decode(token,{complete: true});
                console.log(decoded);
                const iss = this.$store.getters.user.signInUserSession.idToken.payload.iss;
                console.log(iss);
                const keysReq = await axios.get(iss+"/.well-known/jwks.json");
                const keys = keysReq.data.keys;
                console.log(keys);
                const kid = decoded.header.kid;
                console.log("kid:" + kid);
                const key = keys.filter(function(k){
                    return k.kid === kid;
                });
                console.log(key);
                const pem = jwkToPem(key[0]);
                console.log("pem="+pem);
                const validToken = jwt.verify(token,pem,{complet: true});
                console.log(validToken);

            } catch (err) {
                console.log("error");
                console.log(err);
            }

        },
        async cliccato2() {
            console.log("cliccato2!")
            try {
                let resp = await API.get('testapi2','/items',{
                    queryStringParameters: {
                        id: "1",
                        nome: "fabio"
                    }
                })
                console.log(resp)
            } catch (err) {
                console.log("errore")
                console.log(err)
            }

        },
        async cliccato3() {
            console.log("cliccato 3")
            try {
               //let token = this.$store.getters.user.signInUserSession.idToken.jwtToken;
               //let wsUrl = process.env.VUE_APP_WEBSOCKET_URL + "?token=" + token;
               //this.$connect(wsUrl);
                let msg = {action:"azione",data:"dati"}
                this.$socket.sendObj(msg)
                console.log("messaggio inviato")

            } catch (err) {
                console.log("errore")
                console.log(err)
            }

        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            this.saveSubmit=true;
            // Trigger submit handler
            this.saveProfile();
        },
        saveProfile() 
        {    
        console.log("Inizio procedura di salvataggio dati profilo in DB");
        if ((this.userType=="installer" || this.userType=="client" || this.userType=="basic") && this.picked=="company")
        {
          if(this.userName!="" && this.userSurname!="" && this.userbusinessName!="" && this.userPiva!="" && this.userPhone!="" && this.userStreet!="" && this.userNumber!="" && this.userCity!="" && this.userCap!="" && this.userProv!="" && this.userCountry!="")
          {
            console.log("Salva dati aziendali in DB"); 
            this.$store.dispatch("dbSaveProfile",{"name":this.userName, "surname":this.userSurname, "businessname":this.userbusinessName, "piva":this.userPiva,"phone":this.userPhone, "street":this.userStreet,"housenumber":this.userNumber, "number":this.userNumber,"city":this.userCity,"cap":this.userCap,"prov":this.userProv,"country":this.userCountry,"userType":this.userType});
            this.$router.go();
              // Hide the modal manually
              this.$nextTick(() => {
                this.$refs.modal.hide()
              })
          }
        }
        else
        {
          if(this.userName!="" && this.userSurname!="" && this.userPhone!="" && this.userStreet!="" && this.userNumber!="" && this.userCity!="" && this.userCap!="" && this.userProv!="" && this.userCountry!="")
          {
            console.log("Salva dati personali in DB"); 
            this.$store.dispatch("dbSaveProfile",{"name":this.userName, "surname":this.userSurname, "phone":this.userPhone, "street":this.userStreet,"housenumber":this.userNumber, "number":this.userNumber,"city":this.userCity,"cap":this.userCap,"prov":this.userProv,"country":this.userCountry,"userType":this.userType});
            this.$router.go();
              // Hide the modal manually
              this.$nextTick(() => {
              this.$refs.modal.hide()
             })
          }
          else
          {
            console.log("Errore start procedura");
          }
        }  
    }   
    }
}
</script>

<style scoped>

.backgroundGradient{
    background-image:
    linear-gradient(90deg, #FFFFFFFF 40%, #FFFFFF00 100%),
    url('/img/backgroundHome.jpg');
    background-size: cover;
}

</style>

